import { render, staticRenderFns } from "./leave-add-or-update.vue?vue&type=template&id=19f776bd&scoped=true"
import script from "./leave-add-or-update.vue?vue&type=script&lang=js"
export * from "./leave-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./leave-add-or-update.vue?vue&type=style&index=0&id=19f776bd&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f776bd",
  null
  
)

export default component.exports